
import Vue from "vue";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules/index";
import { GREEN_MAP_PIN_ICON, MAP_STYLES, ORDER_TYPE_RETURN, RED_MAP_PIN_ICON } from "@/consts";
import { formatBool, getOrderLocation, getOrderLocationParty, getOrdersMapLocation } from "@/utils";
import { GoogleMapInterface } from "@/models/ui/googleMapVue";

const orderModule = getModule(OrderModule);

@Component({
  data: () => {
    return {
      customBus: new Vue(),
    };
  },
})
export default class OrderMap extends Vue {
  @Prop({ required: false, default: () => null })
  public orders: any[];

  orderInfoWindowOpened: boolean = false;
  orderInfoWindowOptions: any = null;
  orderInfoWindowPos: any = null;
  mapCenter: any = null;
  mapZoomLevel: number = 10;
  selectedMapOrder: any;

  @Watch("orders", { immediate: true })
  onOrdersChange(val: any[]) {
    if (
      this.orders &&
      this.ordersWithLocation &&
      this.ordersWithLocation.length > 0
    ) {
      let mapInfo = getOrdersMapLocation(this.ordersWithLocation);
      this.mapCenter = { lat: mapInfo.latCenter, lng: mapInfo.lngCenter };
      this.mapZoomLevel = mapInfo.zoomLevel;
    } else {
      this.mapCenter = { lat: 0, lng: 0 };
      this.mapZoomLevel = 10;
    }
  }

  get ordersWithLocation() 
  {
    return this.orders ? this.orders.filter(x => this.getOrderPosition(x)) : []
  }

  get ordersWithoutLocation() 
  {
    return this.orders ? this.orders.filter(x => !this.getOrderPosition(x)) : []
  }

  getOrderPosition(order: any) {
    var location = getOrderLocation(order)
    if (location)
      return { lat: location.latitude, lng: location.longitude };
    return null;
  }

  getOrderMapIcon(order: any) {
    var location = getOrderLocation(order)
    if (location && location.isZipCodeLocation == true)
      return RED_MAP_PIN_ICON;
    return GREEN_MAP_PIN_ICON;
  }

  getMapOptions() {
    return MAP_STYLES;
  }

  selectMapOrder(order) {
    this.selectedMapOrder = order;
    this.orderInfoWindowOpened = order != null;
    this.orderInfoWindowOptions = this.getOrderInfoWindowOptions();
    this.orderInfoWindowPos = this.getOrderPosition(order);
  }

  getOrderInfoWindowOptions() {
    if (this.selectedMapOrder) {
      var locationParty = getOrderLocationParty(this.selectedMapOrder);
      return {
        content:
          "</h5><b>SYS #:</b> " +
          this.selectedMapOrder.number +
          " <b>CRN:</b> " +
          this.selectedMapOrder.crn +
          " <b>Cubes:</b> " +
          this.selectedMapOrder.cubes +
          " <b>Received:</b> " +
          formatBool(this.selectedMapOrder.isReceived) + 
          "<br/>" + (locationParty ?
          locationParty.name +
          "<br/>" +
          locationParty.address.streetLine1 +
          "<br/>" +
          locationParty.address.city +
          ", " +
          locationParty.address.state +
          " " +
          locationParty.address.zip : '')
      };
    }
    return null;
  }

  refreshMap() {
    var orderMap = this.$refs.orderMAp as GoogleMapInterface;
    var vue = this;
    orderMap.$mapPromise.then((map) => {
      vue.$data.customBus.$emit("resize");
    });
  }
}
